import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { cloudloyalty } from 'Services/Apis/clients';

export const fetchCartUnavailableThunk = createAsyncThunk(
    `FetchCartUnavailableSlicer/fetchCartUnavailableThunk`,
    async (zipcode, { getState, rejectWithValue }) => {
            const { user } = getState().oidc;

            try {
                const { data } = await cloudloyalty(user).get(
                    `/v1/carts/me/shipping/rates/${zipcode}/sku`
                );
                return data;

            } catch (err) {
                return rejectWithValue(err)
            }
    }
);

const initialState = {
    errorListSkuUnavailable: [],
    dataListSkuUnavailable: null,
};

const FetchCartUnavailableSlicer = createSlice({
    name: 'FetchCartUnavailable',
    initialState,
    reducers: {
        resetDataListSkuUnavailable: (state) => {
            state.errorListSkuUnavailable = null;
            state.dataListSkuUnavailable = null;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(fetchCartUnavailableThunk.fulfilled, (state, action) => {
            state.dataListSkuUnavailable = action.payload.success;
        });
        
        builder.addCase(fetchCartUnavailableThunk.rejected, (state, action) => {
            state.dataListSkuUnavailable = action.payload.success;
            state.errorListSkuUnavailable = action.payload?.response?.data?.errorSkus;
        });
    },
});

export const { resetDataListSkuUnavailable } = FetchCartUnavailableSlicer.actions;
export default FetchCartUnavailableSlicer.reducer;
